import React from 'react';
import { Helmet } from 'react-helmet-async';
import { EyeIcon, TargetIcon, CheckCircleIcon } from 'lucide-react';
export function VisionMissionPage() {
  const missions = ['Menjalankan operasional ground handling yang lancar dan efisien', 'Menjamin keamanan dan kenyamanan dalam setiap penerbangan', 'Mengutamakan profesionalisme dan kepatuhan terhadap regulasi penerbangan', 'Berinovasi untuk menciptakan ekosistem penerbangan yang aman dan andal', 'Membangun kemitraan jangka panjang dengan maskapai penerbangan', 'Mengembangkan SDM yang kompeten dan berdedikasi tinggi'];
  return <div className="w-full" data-id="element-479">
      <Helmet data-id="element-480">
        <title data-id="element-481">
          Visi & Misi - PT Jagat Indo Perkasa | Komitmen Keselamatan &
          Keunggulan Ground Handling
        </title>
        <meta name="description" content="Visi PT Jagat Indo Perkasa: Memberikan pelayanan ground handling terbaik dengan standar keselamatan tertinggi dan menjadi mitra terpercaya dalam industri penerbangan Indonesia. Misi kami mencakup operasional efisien, keamanan penerbangan, inovasi berkelanjutan, dan pengembangan SDM profesional." data-id="element-482" />
        <meta name="keywords" content="visi misi PT Jagat Indo Perkasa, komitmen ground handling, standar keselamatan penerbangan, inovasi ground handling Indonesia, keunggulan operasional, mitra maskapai terpercaya, SDM ground handling" data-id="element-483" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-484" />
        <meta name="robots" content="index, follow" data-id="element-485" />
        <link rel="canonical" href="https://jagatindoperkasa.id/vision-mission" data-id="element-486" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-487" />
        <meta property="og:url" content="https://jagatindoperkasa.id/vision-mission" data-id="element-488" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-489" />
        <meta property="og:title" content="Visi & Misi PT Jagat Indo Perkasa - Komitmen Ground Handling" data-id="element-490" />
        <meta property="og:description" content="Komitmen kami untuk memberikan layanan ground handling terbaik dengan standar keselamatan tertinggi dan menjadi mitra terpercaya dalam industri penerbangan Indonesia." data-id="element-491" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-492" />
        <meta property="og:locale" content="id_ID" data-id="element-493" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-494" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/vision-mission" data-id="element-495" />
        <meta name="twitter:title" content="Visi & Misi PT Jagat Indo Perkasa" data-id="element-496" />
        <meta name="twitter:description" content="Komitmen keselamatan dan keunggulan dalam layanan ground handling Indonesia" data-id="element-497" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-498" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-499">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-500">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-501">Visi & Misi</h1>
          <p className="text-xl text-sky-100" data-id="element-502">
            Arah dan tujuan kami dalam memberikan layanan ground handling
            terbaik
          </p>
        </div>
      </section>
      {/* Vision & Mission Cards */}
      <section className="py-16 bg-white" data-id="element-503">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-504">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-505">
            {/* Vision Card */}
            <div className="bg-gradient-to-br from-sky-50 to-blue-50 p-8 md:p-12 rounded-2xl shadow-lg" data-id="element-506">
              <div className="flex items-center space-x-4 mb-6" data-id="element-507">
                <div className="w-16 h-16 bg-sky-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-508">
                  <EyeIcon className="w-8 h-8 text-white" data-id="element-509" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900" data-id="element-510">Visi</h2>
              </div>
              <p className="text-xl text-gray-700 leading-relaxed" data-id="element-511">
                Memberikan pelayanan ground handling terbaik dengan standar
                keselamatan tertinggi dan menjadi mitra terpercaya dalam
                industri penerbangan Indonesia.
              </p>
            </div>
            {/* Mission Card */}
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 md:p-12 rounded-2xl shadow-lg" data-id="element-512">
              <div className="flex items-center space-x-4 mb-6" data-id="element-513">
                <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-514">
                  <TargetIcon className="w-8 h-8 text-white" data-id="element-515" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900" data-id="element-516">Misi</h2>
              </div>
              <ul className="space-y-4" data-id="element-517">
                {missions.map((mission, index) => <li key={index} className="flex items-start space-x-3" data-id="element-518">
                    <CheckCircleIcon className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-519" />
                    <span className="text-gray-700" data-id="element-520">{mission}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Commitment Section */}
      <section className="py-16 bg-gray-50" data-id="element-521">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522">
          <div className="text-center max-w-3xl mx-auto" data-id="element-523">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-524">
              Komitmen Kami
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-525">
              Kami berkomitmen untuk terus meningkatkan kualitas layanan ground
              handling dengan mengutamakan keselamatan, efisiensi, dan kepuasan
              pelanggan. Setiap anggota tim kami bekerja dengan dedikasi penuh
              untuk memastikan setiap operasi berjalan dengan sempurna.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-526">
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-527">
                <div className="text-4xl font-bold text-sky-600 mb-2" data-id="element-528">100%</div>
                <div className="text-gray-600" data-id="element-529">Komitmen Keselamatan</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-530">
                <div className="text-4xl font-bold text-sky-600 mb-2" data-id="element-531">24/7</div>
                <div className="text-gray-600" data-id="element-532">Layanan Siap Sedia</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-533">
                <div className="text-4xl font-bold text-sky-600 mb-2" data-id="element-534">ISO</div>
                <div className="text-gray-600" data-id="element-535">Standar Internasional</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}